var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.16406 14.1282H13.9991",
    stroke: "#252525",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.52001 3.02986C9.0371 2.41186 9.96666 2.32124 10.5975 2.82782C10.6324 2.85531 11.753 3.72586 11.753 3.72586C12.446 4.14479 12.6613 5.0354 12.2329 5.71506C12.2102 5.75146 5.87463 13.6763 5.87463 13.6763C5.66385 13.9393 5.34389 14.0945 5.00194 14.0982L2.57569 14.1287L2.02902 11.8149C1.95244 11.4895 2.02902 11.1478 2.2398 10.8849L8.52001 3.02986Z",
    stroke: "#252525",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.34766 4.50098L10.9825 7.29239",
    stroke: "#252525",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.c841e0a846108cd88a5bede0feb87d41.svg";
export { ForwardRef as ReactComponent };